export class SelectedExtrasDto {
  public additionalTools: boolean = false;
  public imageEditor: boolean = false;
  public promptMathAI: boolean = true;
  public database: boolean = false;
  public todoList: boolean = false;

  constructor(data: any) {
    if (data) {
      this.additionalTools = data.additionalTools ?? false;
      this.imageEditor = data.imageEditor ?? false;
      this.promptMathAI = data.promptMathAI ?? true;
      this.database = data.database ?? false;
      this.todoList = data.todoList ?? false;
    }
  }
}
